import { IResourceDefinition } from './types'

/**
 * Company and Responsible answer "whose resource is this", so every resource that
 * exposes them wants the same treatment: seeded from whoever is creating the
 * record, and mandatory.
 *
 * The two settings are deliberately declared together — marking a property
 * mandatory is only safe while something populates it, otherwise creation opens
 * with a blank required field and blocks on it.
 */
export const RESOURCE_OWNER_KEYS = {
  user: 'responsible',
  company: 'company',
} as const

export const OWNER_FORM_DEFAULTS: Pick<
  NonNullable<IResourceDefinition['form']>,
  'defaultRequiredKeys' | 'createDefaults'
> = {
  defaultRequiredKeys: [RESOURCE_OWNER_KEYS.company, RESOURCE_OWNER_KEYS.user],
  createDefaults: {
    [RESOURCE_OWNER_KEYS.user]: 'currentUser',
    [RESOURCE_OWNER_KEYS.company]: 'currentUserCompany',
  },
}
